import { useMutation } from "@tanstack/react-query";
import { useShallow } from "zustand/shallow";
import { useUIStore } from "../stores/ui-store";
import { UIState } from "../types/ui-types";
import { fetchOrganizationReports } from "../api/organization.api";

const useOrganizationReports = () => {
  const [bearerToken] = useUIStore(
    useShallow((state: UIState) => [state.bearerToken])
  );

  const getOrganizationReports = async ({
    companyId,
    organizationId,
  }: {
    companyId: number;
    organizationId: number;
  }) => {
    const result = await getOrganizationReportsMutation.mutateAsync({
      companyId,
      organizationId,
    });
    return result;
  };

  const getOrganizationReportsMutation = useMutation({
    mutationFn: async ({
      companyId,
      organizationId,
    }: {
      companyId: number;
      organizationId: number;
    }): Promise<Report[]> => {
      return await fetchOrganizationReports(
        bearerToken as string,
        companyId,
        organizationId
      );
    },
  });

  const isLoadingOrganizationReports = getOrganizationReportsMutation.isPending;

  return {
    getOrganizationReports,
    isLoadingOrganizationReports,
  };
};

export default useOrganizationReports;
